import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export function CuttingHistoryCard({ history }) {
  return (
    <Card>
      <CardHeader><CardTitle>Recent Cutting Operations</CardTitle></CardHeader>
      <CardContent>
        {history.length === 0 ? (
          <div className="text-center text-muted-foreground py-8">No cutting history</div>
        ) : (
          <HistoryTable history={history} />
        )}
      </CardContent>
    </Card>
  );
}

function HistoryTable({ history }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-muted/50">
          <tr>
            <th className="px-4 py-2 text-left text-sm">Date</th>
            <th className="px-4 py-2 text-left text-sm">Item</th>
            <th className="px-4 py-2 text-left text-sm">Source</th>
            <th className="px-4 py-2 text-left text-sm">Wastage</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {history.slice(0, 10).map(function(h) {
            return (
              <tr key={h.id}>
                <td className="px-4 py-2 text-sm">{new Date(h.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-2 font-mono text-sm">{h.item_code}</td>
                <td className="px-4 py-2 text-sm">{h.source === 'csv_upload' ? 'CSV' : 'Manual'}</td>
                <td className="px-4 py-2 text-sm">{h.total_wastage_mm?.toFixed(0) || 0}mm</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
